import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  InjectedFormProps,
  formValueSelector,
  reduxForm,
} from "redux-form";
import { AppState } from "../../../../store/app_state";

import BadgeBorder from "src/presentation/common/atom/badge/badge_border";
import FormGroupTextareaConnectRf from "src/presentation/common/molecular/form_group/form_group_textarea_connect_rf";
import ScoutCustomerCard from "src/presentation/common/organism/card/scout_customer_card";
import styled from "styled-components";
import { projectConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import {
  ConstBorderRound,
  ConstColor,
} from "../../../../../config/styles_const/styles_const";
import { Customer } from "../../../../../domain/model/customer";
import { JobCareer } from "../../../../../domain/model/job_career";
import { Occupation, Project } from "../../../../../domain/model/project";
import { extractOccupationsFromJobCareers } from "../../../../../util/helper_job_career";
import BtnCancelSmall from "../../../../common/atom/btn/btn_cancel_small";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";


const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  formValuesCustomer: any;
  formValuesProjectId: any;
}

interface IProps extends IStateProps {
  projects: Project[];
  jobCareers: JobCareer[];
  handlePreviousStep: (values: any) => void;
  defaultText: string;
}

interface IState {}

export class ClientScoutCustomerMainScoutThirdForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {};
  }

  public componentDidMount() {
    this.props.change("message", this.props.defaultText);
  }

  public render(): JSX.Element {
    const { handleSubmit, submitting } = this.props;

    const { projects, jobCareers } = this.props;

    if (!projects) {
      return <div />;
    }

    // projectId: Projectの連想配列を作成し連携させる。
    const hashProject: { [projectId: string]: Project } = {};
    for (const item of projects) {
      hashProject[item.id] = item;
    }

    const customer: Customer = this.props.formValuesCustomer;
    const customerName: string = customer.name;
    const customerIconURL: string = customer.getIconURL();
    const customerAddress: string = customer.address;
    const customerPr: string = customer.pr;
    const occupations: Occupation[] =
      extractOccupationsFromJobCareers(jobCareers);
    const isOccupations: boolean = occupations.length !== 0;

    const project = hashProject[this.props.formValuesProjectId];

    let res: JSX.Element;

    // 最終確認
    res = (
      <form
        name="ClientScoutCustomerMainScoutForm-third"
        onSubmit={handleSubmit}
      >
        <H1>スカウトの最終確認</H1>

        <Desc>
          ✅ 以下の情報でスカウトを実行します。
          <br />
          ✅
          スカウトを実行すると、エキスパートと直接やり取りが行えるメッセージルームが立ち上がります。
          <br />✅ そのルーム内で面談の調整をお願いいたします。
        </Desc>

        <H2>対象のエキスパート</H2>

        <ScoutCustomerCard
          customer={customer}
          jobCareers={jobCareers}
          isBookmarked={false}
          cardURL={``}
        />

        <H2>対象の案件</H2>

        <ProjectWrappr>
          <ProjectThumbnail src={project.getThumbnailURL()} />
          <ProjectInfo>
            <ProjectTitleContainer>
              <ProjectTitle>{project.name}</ProjectTitle>
              <ProjectCondition>
                <div style={{ marginRight: 10 }}>報酬/月</div>
                <div style={{ fontSize: 15, fontWeight: "bold" }}>
                  {project.getPaymentRangeString()}
                </div>

                <div style={{ marginRight: 10, marginLeft: 20 }}>時間/月</div>
                <div style={{ fontSize: 15, fontWeight: "bold" }}>
                  {project.getWorkingHourRangeString()}
                </div>
              </ProjectCondition>
            </ProjectTitleContainer>

            <ProjectOccupations>
              {project.occupations.map(
                (occupation: Occupation, index: number) => {
                  return (
                    <OccupationBlock key={index} style={{ marginRight: 10 }}>
                      {projectConfig.occupationList.get(occupation)}
                    </OccupationBlock>
                  );
                }
              )}
            </ProjectOccupations>
          </ProjectInfo>

          <ProjectStatus>{project.statusString()}</ProjectStatus>
        </ProjectWrappr>

        <H2>スカウト実行後の流れ</H2>

        <FlowContainer>
          <FlowBox>
            <FlowBoxTitle>スカウト実行</FlowBoxTitle>
            <FlowBoxIcon>🚀</FlowBoxIcon>
            <FlowBoxDesc>
              上記のエキスパートと案件に間違いが無いか確認し、スカウトを実行します。
            </FlowBoxDesc>
          </FlowBox>

          <FlowBox>
            <FlowBoxTitle>面談の調整</FlowBoxTitle>
            <FlowBoxIcon>📧</FlowBoxIcon>
            <FlowBoxDesc>
              メッセージルームから日程調整や必要書類のやり取りを実施頂きます。
            </FlowBoxDesc>
          </FlowBox>

          <FlowBox>
            <FlowBoxTitle>面談の実施</FlowBoxTitle>
            <FlowBoxIcon>👬</FlowBoxIcon>
            <FlowBoxDesc>
              オンラインもしくはオフィスで面談を実施頂き、要件に合致するかご確認頂きます。
            </FlowBoxDesc>
          </FlowBox>

          <FlowBox>
            <FlowBoxTitle>成約</FlowBoxTitle>
            <FlowBoxIcon>🎊</FlowBoxIcon>
            <FlowBoxDesc>
              ぴったりなエキスパートが見つかった場合、貴社とエキスパート間で契約を結んで頂きます。
            </FlowBoxDesc>
          </FlowBox>

          <FlowBox>
            <FlowBoxTitle>成約報告</FlowBoxTitle>
            <FlowBoxIcon>📢</FlowBoxIcon>
            <FlowBoxDesc>
              契約後、システムを通じて弊社に成約報告を行って頂きます。
            </FlowBoxDesc>
          </FlowBox>
        </FlowContainer>

        <Field
          label={"エキスパートに送信するメッセージ"}
          name="message"
          rows={3}
          component={FormGroupTextareaConnectRf}
          validate={[]}
        />

        <p
          style={{
            marginTop: 45,
            marginBottom: 10,
            fontSize: 12,
            width: "100%",
            textAlign: "center",
          }}
        >
          上記の内容をご確認いただいたうえで、スカウトを実行してください。
        </p>

        <ScoutButtonWrapper>
          <ScoutButton
            name="ClientScoutCustomerMainScoutForm-third-submit"
            type="submit"
            disabled={submitting}
            widthSize={"200px"}
          >
            スカウト
          </ScoutButton>
        </ScoutButtonWrapper>
        <CancelButtonWrapper>
          <BtnCancelSmall
            name="ClientScoutCustomerMainScoutForm-third-back"
            type="button"
            widthSize={"100px"}
            onClick={this.props.handlePreviousStep}
          >
            戻る
          </BtnCancelSmall>
        </CancelButtonWrapper>
      </form>
    );

    return res;
  }
}

const selector = formValueSelector("ClientScoutCustomerMainScoutForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValuesCustomer: selector(state, "customer"),
    formValuesProjectId: selector(state, "projectId"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "ClientScoutCustomerMainScoutForm",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientScoutCustomerMainScoutThirdForm)
);

const H1 = styled.h1`
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 8px;
  line-height: 42px;
`;

const Desc = styled.div`
  font-size: 16px;
  margin-bottom: 36px;
  line-height: 25px;
`;

const H2 = styled.h1`
  font-size: 18px;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 8px;
  line-height: 25px;
`;

const ProjectNameWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const ScoutButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const ScoutButton = styled(BtnCorporateLarge)`
  background: #9a8c64;
`;

const CancelButtonWrapper = styled.div`
  text-align: center;
`;

const ProjectWrappr = styled.div`
  border: 1px solid #d8d8d8;
  padding: 10px;
  display: flex;
  position: relative;
`;

const ProjectStatus = styled.div`
  padding: 4px 10px;
  background-color: #00d58e;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  left: 0px;
  top: 45px;
`;

const ProjectThumbnail = styled.img`
  width: 140px;
  height: 90px;
  object-fit: cover;
  display: block;
`;

const ProjectInfo = styled.div`
  flex: 1;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ProjectTitleContainer = styled.div`
  display: flex;
`;

const ProjectTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  flex: 1;
`;

const ProjectCondition = styled.div`
  font-size: 12px;
  line-height: 18px;
  width: 300px;
  display: flex;
  justify-content: flex-end;
`;

const ProjectOccupations = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const OccupationBlock = styled(BadgeBorder)`
  color: ${ConstColor.Gray};
  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  background-color: ${ConstColor.White};
  border-radius: ${ConstBorderRound.BadgeBorder};
`;

const FlowContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
  margin-bottom: 50px;
`;

const FlowBox = styled.div`
  border: 1px solid #d8d8d8;
  padding: 15px;
`;

const FlowBoxTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  text-align: center;
`;

const FlowBoxIcon = styled.div`
  font-size: 30px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const FlowBoxDesc = styled.div`
  font-size: 13px;
  line-height: 18px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_third/client_scout_customer_main_scout_third_form.tsx